export enum DonorStatusField {
  status = 'status',
  RetiredReason = 'retiredReason',
  RetiredClarification = 'retiredClarification',
}
